import {
  Pagination as _Pagination,
  PaginationProps as _PaginationProps
} from "reactstrap";

export const Pagination = _Pagination;
export type PaginationProps = _PaginationProps;
